import { useContext, useEffect, useState } from "react";
import {
  handleSignUpSubmit,
  signUpInitial,
  handleChange,
  passwordChange,
} from "../ah1/ah1.utils";
import "./aho1-home.styles.scss";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../contexts/users.context";
import AffiliateModal from "../affiliateModal/affiliateModal.component";
const AHO1Home = () => {
  const [signUpFields, setSignUpFields] = useState(signUpInitial);
  const [loaderClass, setLoaderClass] = useState("aho1-loader-hidden");
  const { restaurantName, restaurantEmail, adminName, adminPassword } =
    signUpFields;
  const { user } = useContext(UserContext);
  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user]);
  const [modalClass, setModalClass] = useState("ah-affiliate-hidden");
  const [accountType, setAccountType] = useState("");
  const handleClick = (type) => {
    setAccountType(type);
    if (modalClass === "ah-affiliate-hidden") {
      setModalClass("ah-affiliate-view");
    } else {
      setModalClass("ah-affiliate-hidden");
    }
  };
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  return (
    <div className="aho1-home-container">
      <div className={loaderClass}>
        <div className="loader"></div>
      </div>
      <div className={modalClass}>
        <span className="ah-modal-goback" onClick={() => handleClick("")}>
          GO BACK
        </span>
        <AffiliateModal accountTypeValue={accountType} />
      </div>
      <div className="ah-one-home">
        <div className="ah-one-home-left">
          <span className="ah-one-left-message-one">
            Waitr provides your restaurant the technological push towards
            efficiency and satisfied customers.
          </span>
          <span className="ah-one-left-message-two">YOUR RESTAURANT BUDDY</span>
        </div>
        <div className="ah-one-home-right">
          <form
            onSubmit={(event) => {
              handleSignUpSubmit(
                event,
                signUpFields,
                adminPassword,
                confirmPassword,
                setLoaderClass
              );
            }}
          >
            <span className="ah-one-su-title">START YOUR JOURNEY HERE</span>
            <input
              type="text"
              name="restaurantName"
              className="ah-one-su-input"
              value={restaurantName}
              placeholder="Restaurant Name"
              onChange={(event) =>
                handleChange(event, signUpFields, setSignUpFields)
              }
            />

            <input
              type="text"
              name="adminName"
              className="ah-one-su-input"
              value={adminName}
              placeholder="Admin Name"
              onChange={(event) =>
                handleChange(event, signUpFields, setSignUpFields)
              }
            />
            <input
              type="text"
              name="restaurantEmail"
              className="ah-one-su-input"
              value={restaurantEmail}
              placeholder="Restaurant Email"
              onChange={(event) =>
                handleChange(event, signUpFields, setSignUpFields)
              }
            />
            <input
              type="password"
              name="adminPassword"
              className="ah-one-su-input"
              value={adminPassword}
              placeholder="Password"
              onChange={(event) =>
                handleChange(event, signUpFields, setSignUpFields)
              }
            />
            <input
              type="password"
              name="confirmPassword"
              className="ah-one-su-input"
              value={confirmPassword}
              placeholder="Confirm Password"
              onChange={(event) => passwordChange(event, setConfirmPassword)}
            />
            <button type="submit" className="ah-one-su-submit">
              Start Your Journey
            </button>
            <div className="ah-one-or-container">
              <span className="ah-one-or">or</span>
            </div>

            <div className="ah-one-left-buttons">
              <span
                className="ah-one-left-button"
                onClick={() => handleClick("Host")}
              >
                Host Account
              </span>
              <span
                className="ah-one-left-button"
                onClick={() => handleClick("Kitchen")}
              >
                Kitchen Account
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default AHO1Home;
